import React from 'react'
import * as models from '../models/index'
var d3 = require('d3')

class DonutCharts extends React.Component<{
  customer?: string
  student?: string
  onLoaded?: Function
  refresh?: boolean
}> {
  state = {
    weeks: null,
    years: null,
    percentChange: null,
  }

  removeChildren = (id) => {
    var parent = document.getElementById(id)
    if (parent) {
      var child = parent.lastElementChild
      while (child) {
        parent.removeChild(child)
        child = parent.lastElementChild
      }
    }
  }

  addDonutChart = (total, completed, probe) => {
    var percent = (completed / total) * 100

    var data = [{ value: percent }, { value: (100 - percent).toFixed(1) }]

    var width = 120
    var height = 120
    var thickness = 20

    var radius = Math.min(width, height) / 2
    var color = d3.scaleOrdinal(['#0055BB', '#DCDCDC'])

    //set up SVG
    var svg = d3
      .select('#' + probe.toLowerCase())
      .append('svg')
      .attr('class', 'pie')
      .attr('width', width)
      .attr('height', height)

    //center the circle in the SVG
    var g = svg
      .append('g')
      .attr('transform', 'translate(' + width / 2 + ',' + height / 2 + ')')

    //create group for text
    var textGroup = g.append('g')

    //set the arc
    var arc = d3
      .arc()
      .innerRadius(radius - thickness)
      .outerRadius(radius)

    //create pie
    var pie = d3
      .pie()
      .value(function (d) {
        return d.value
      })
      .sort(null)

    g.selectAll('path')
      .data(pie(data))
      .enter()
      .append('g')
      .append('path')
      .attr('d', arc)
      .attr('fill', function (d, i) {
        return color(i)
      })
      .each(function (d, i) {
        this._current = i
      })

    g.append('text').attr('text-anchor', 'middle').attr('dy', '0em').text(probe)

    textGroup
      .append('text')
      .attr('text-anchor', 'middle')
      .attr('dy', '1.5em')
      .text(completed + '/' + total)
  }

  componentDidMount() {
    this.loadDonuts()
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.refresh && this.props.refresh) {
      this.loadDonuts()
    }
  }

  loadDonuts = () => {
    models.donuts
      .get({
        customerUsername: this.props.customer ?? null,
        studentName: this.props.student,
      })
      .then((donutData) => {
        if (donutData.valid) {
          this.removeChildren('phonics')
          this.removeChildren('phrases')
          this.removeChildren('stories')
          this.addDonutChart(
            donutData.phonics.total,
            donutData.phonics.completed,
            'Phonics'
          )
          this.addDonutChart(
            donutData.phrases.total,
            donutData.phrases.completed,
            'Phrases'
          )
          this.addDonutChart(
            donutData.stories.total,
            donutData.stories.completed,
            'Stories'
          )

          this.setState({
            weeks: donutData.stories.weeks,
            years: donutData.stories.years,
            percentChange: donutData.stories.wpmPercentChange,
          })

          if (this.props.onLoaded) {
            this.props.onLoaded()
          }
        }
      })
  }

  render() {
    var { weeks, years, percentChange } = this.state
    // weeks = 58
    // years = 3
    // percentChange = 100
    return (
      <div id="donut-charts" className="row">
        <div id="phonics" className="col-4 col-md-4"></div>

        <div id="phrases" className="col-4 col-md-4"></div>

        <div id="stories" className="col-4 col-md-4"></div>

        <h3 id="progress-message" className="w-100 pt-3 pb-3">
          {years > 0
            ? `In
                        ${
                          weeks < 8.69049 //2 months
                            ? weeks + ' weeks'
                            : weeks < 52.1429 //1 year
                            ? (weeks / 4.34524).toFixed(1) + ' months'
                            : (weeks / 52).toFixed(1) + ' years'
                        }
                    
                     - you have progressed by ${years} year${
                years > 1 ? 's' : ''
              }${
                percentChange > 0
                  ? ` with a ${Math.round(percentChange)}% increase in rate`
                  : ''
              }!!`
            : ''}
        </h3>
      </div>
    )
  }
}

export default DonutCharts
